import React, { Component, Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { change } from 'redux-form';
import { fromJS } from 'immutable';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';

import DropdownList from 'react-widgets/lib/DropdownList';
import Multiselect from 'react-widgets/lib/Multiselect';
import 'react-widgets/dist/css/react-widgets.css';
import './DropdownSearchField.css';

import InlineField from '../InlineField';
import Message from '../ValidationMessage';
import { dropdownFetchMount } from './actions';
import messagesCommon from '../../../../common/translation_common';
import messagesDropdown from './translation_dropdownsearchfield';
import { debounce } from 'lodash';

class DropdownSearchField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initSearch: false,
      selectedValue: null
    };

    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleOnSearch = this.handleOnSearch.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.renderItemDropdownComponent = this.renderItemDropdownComponent.bind(
      this
    );
  }

  componentDidMount() {
    const {
      input,
      type,
      isFix,
      preload,
      multiple,
      dropdownFetchMount,
      fields,
      searchParams
    } = this.props;

    const { value, name } = input || {};

    if (!isFix) {
      if (!isEmpty(value)) {
        const idArr = multiple
          ? value
          : [].concat(value._id || value.id || value);
        dropdownFetchMount(name, idArr, type, fields, preload, searchParams);
      } else if (preload) {
        dropdownFetchMount(name, [], type, fields, preload, searchParams);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      searchParams: prevSearchParams = {},
      input: prevInput = {}
    } = prevProps;

    const {
      input: currInput = {},
      listOptions: currList = [],
      searchParams: currSearchParams = {},
      isFetching: currIsFetching
    } = this.props;

    const { initSearch } = this.state;

    if (
      !fromJS(prevSearchParams).equals(fromJS(currSearchParams)) ||
      !fromJS(prevInput).equals(fromJS(currInput))
    ) {
      this._doSearch();
    }

    if (
      !isEmpty(currInput.value) &&
      isEmpty(currList) &&
      !currIsFetching &&
      !initSearch
    ) {
      this.setState({ initSearch: true });
      this._doSearch();
    }
  }

  shouldComponentUpdate(nextProps) {
    const nextObject = {
      searchTerm: nextProps.searchTerm,
      searchParams: nextProps.searchParams,
      listOptions: nextProps.listOptions,
      isFetching: nextProps.isFetching,
      listError: nextProps.listError,
      value: nextProps.input.value,
      displayType: nextProps.displayType,
      disabled: nextProps.disabled,
      meta: nextProps.meta,
      multiple: nextProps.multiple,
    };

    const currObject = {
      searchTerm: this.props.searchTerm,
      listOptions: this.props.listOptions,
      searchParams: this.props.searchParams,
      isFetching: this.props.isFetching,
      listError: this.props.listError,
      value: this.props.input.value,
      displayType: this.props.displayType,
      disabled: this.props.disabled,
      meta: this.props.meta,
      multiple: this.props.multiple,
    };

    return !fromJS(currObject).equals(fromJS(nextObject));
  }

  _resolveListOptions() {
    const {
      listOptions = [],
      textField = 'name',
      valueField = '_id',
      intl,
      defaultDropdownMsg
    } = this.props;

    const dropdown_default_msg = defaultDropdownMsg
      ? defaultDropdownMsg
      : intl.formatMessage(messagesCommon.dropdown_default_msg);

    const { selectedValue } = this.state;
    const updatedDocs = (listOptions || []).map((doc) =>
      !doc.i18n || !intl.messages[doc.i18n]
        ? { ...doc }
        : { ...doc, [textField]: intl.formatMessage({ id: `${doc.i18n}` }) }
    );

    if (isEmpty(selectedValue)) {
      return updatedDocs;
    }

    const values = [];

    if (Array.isArray(selectedValue)) {
      selectedValue.forEach(val => {
        const foundVal = find(updatedDocs, {
          [valueField]: (val || {})[valueField]
        });
        if (!foundVal && !isEmpty(val)) {
          values.push(val);
        }
      });
    } else {
      const foundVal = find(updatedDocs, {
        [valueField]: selectedValue[valueField]
      });
      if (!foundVal && !isEmpty(selectedValue)) {
        if ((selectedValue || {}).name !== dropdown_default_msg) {
          values.push(selectedValue);
        }
      }
    }

    return updatedDocs.concat(values);
  }

  _getDropdownData() {
    const {
      multiple,
      valueField,
      textField,
      intl,
      defaultDropdownMsg,
      hideDefaultMsg
    } = this.props;

    const options = this._resolveListOptions();

    const dropdown_default_msg = defaultDropdownMsg
      ? defaultDropdownMsg
      : intl.formatMessage(messagesCommon.dropdown_default_msg);

    return !multiple && !hideDefaultMsg
      ? [{ [valueField]: '', [textField]: dropdown_default_msg }].concat(
          options
        )
      : options;
  }

  _getInlineContent(data) {
    const { multiple, input, valueField, textField } = this.props;
    return multiple
      ? data.reduce((res, doc) => {
          return doc && (input.value || []).indexOf(doc[valueField]) > -1
            ? res.concat(doc[textField] || '')
            : res;
        }, [])
      : (find(data, { [valueField]: input.value }) || {})[textField] || '';
  }

  _doSearch(searchTerm) {
    const {
      input: { name, value },
      searchFn,
      dropdownType,
      searchParams,
      fields,
      type,
      isFix,
      valueField
    } = this.props;

    if (isFix) return;

    let id = [];

    if (!isEmpty(value) && (valueField === 'id' || valueField === '_id')) {
      id = Array.isArray(value) ? value : [value];
    }

    searchFn({
      key: name,
      searchTerm,
      type: dropdownType,
      dropdown_type: type,
      searchParams,
      fields,
      id
    });
  }

  handleOnSearch(searchTerm) {
    this._doSearch(searchTerm);
  }

  handleOnToggle(isOpen) {
    const { initSearch } = this.state;

    if (isOpen && !initSearch) {
      this._doSearch();
      this.setState({
        initSearch: true
      });
    }
  }

  handleOnChange(data) {
    const {
      formId,
      form,
      input: { name },
      multiple,
      valueField,
      change,
      onPostChange,
      isNonRedux,
    } = this.props;
    let selectedData = multiple ? [] : data[valueField];

    if (multiple) {
      (data || []).forEach(item => {
        let selected = item[valueField];

        if (!item) {
          return null;
        }

        if (selected === undefined) {
          return item.id;
        }

        selectedData.push(selected);
      });
    }

    if (!multiple && selectedData === undefined) {
      selectedData = data.id;
    }

    if (!isNonRedux) {
      change(formId || form, name, selectedData);
    }

    this.setState({
      selectedValue: data
    });

    if (onPostChange) {
      onPostChange(data);
    }
  }

  handleOnBlur() {
    const { input } = this.props;
    const { onBlur } = input || {};

    if (onBlur) onBlur();
  }

  renderItemDropdownComponent({ item }) {
    if (!item) return null;
    if (isString(item) || isNumber(item)) return item;

    const {
      textFn,
      defaultDropdownMsg,
      intl,
      multiple,
      textField = 'name',
      valueField = '_id'
    } = this.props;

    const dropdown_default_msg = defaultDropdownMsg
      ? defaultDropdownMsg
      : intl.formatMessage(messagesCommon.dropdown_default_msg);

    if ((!isUndefined(textFn) || !isNull(textFn)) && isFunction(textFn)) {
      const textFnResult = textFn(item);

      if (isEmpty(textFnResult)) {
        return dropdown_default_msg;
      }

      return textFnResult;
    } else if (isFunction(textFn) && item[valueField]) {
      return textFn(item);
    } else if (item[textField]) {
      return item[textField];
    } else if (item[valueField]) {
      return item[valueField];
    } else if (!multiple && item[textField] === dropdown_default_msg) {
      return dropdown_default_msg;
    } else {
      return null;
    }
  }

  render() {
    let {
      intl,
      translation,
      id,
      label,
      input,
      disabled,
      required,
      listError,
      isFetching,
      placeholder,
      multiple,
      displayType,
      link = false,
      minLength = 3,
      readOnly = false,
      valueField = '_id',
      textField = 'name',
      groupBy,
      filterMatcher = 'contains',
      dropUp = false,
      defaultValue = null,
      meta,
      isHideMessage,
      isFix,
    } = this.props;

    const { touched, error, warning } = meta || {};

    if (intl && translation) {
      const labelObj = translation.label;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    if (listError) {
      return (
        <div>
          <FormattedMessage
            id="admin.title.failed_load"
            defaultMessage={`Failed to load {label}`}
            values={{ label: label }}
          />
        </div>
      );
    }

    const messages = {
      emptyList: isFetching
        ? intl.formatMessage(messagesDropdown.msg_loading)
        : '',
      emptyFilter: intl.formatMessage(messagesDropdown.msg_empty_filter)
    };

    const data = this._getDropdownData();

    const { name, value } = input || {};

    if (displayType === 'inline') {
      const content = this._getInlineContent(data);
      return (
        <InlineField
          fieldType="renderDropdownField"
          link={link}
          value={value}
          content={content}
          label={label}
          id={id}
        />
      );
    }

    const dropdownProps = {
      ...input,
      name,
      data,
      dropUp,
      messages,
      readOnly,
      disabled,
      minLength,
      textField,
      valueField,
      groupBy,
      defaultValue,
      placeholder,
      busy: isFetching,
      filter: isFix ? filterMatcher : () => true,
      itemComponent: this.renderItemDropdownComponent,
      valueComponent: this.renderItemDropdownComponent,
      onToggle: this.handleOnToggle,
      onSearch: debounce(this.handleOnSearch, 400),
      onBlur: this.handleOnBlur,
      onChange: this.handleOnChange
    };

    let showError = touched && error ? 'error' : '';
    let requiredLabel = required ? 'required' : '';

    return (
      <div className={`${requiredLabel} field ${showError}`}>
        {label && <label>{label}</label>}

        {multiple ? (
          <Multiselect
            {...dropdownProps}
            className="ui fluid search dropdown renderDropdown ks-dropdpown"
            value={value || []}
          />
        ) : (
          <DropdownList
            {...dropdownProps}
            messages={{ filterPlaceholder: placeholder || 'Search' }}
            className={`ui fluid search dropdown renderDropdown ks-dropdpown ${name}`}
          />
        )}

        {!isHideMessage && (
          <Fragment>
            <Message show={touched} message={error} />
            <Message show={touched} message={warning} />
          </Fragment>
        )}
      </div>
    );
  }
}

DropdownSearchField.defaultProps = { valueField: '_id', textField: 'name' };

function mapStateToProps(state, props) {
  const {
    input,
    isFix = false,
    listOptions,
    postDropdownFilter
  } = props;

  const { name } = input || {};

  const { list: ddList, error, isFetching, searchTerm: ddSearchTerm } =
    state.dropdown[name] || {};

  const list = isFix ? listOptions : ddList;
  const filteredList = postDropdownFilter ? postDropdownFilter(list) : list;
  const searchTerm = ddSearchTerm ? ddSearchTerm : '';

  return {
    searchTerm,
    isFetching,
    listOptions: filteredList,
    listError: error
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      change,
      dropdownFetchMount
    },
    dispatch
  );
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DropdownSearchField)
);
